import { IReduxAction, actionGenerator } from '../../redux/actionGenerator';

export const CONFIRM_BUY_PACKAGE = 'BUY_PACKAGE :: CONFIRM';

export type TConfirmBuyPackageAction = IReduxAction<typeof CONFIRM_BUY_PACKAGE>;

export const confirmBuyPackage = actionGenerator<typeof CONFIRM_BUY_PACKAGE>(CONFIRM_BUY_PACKAGE);
